<template>
  <q-footer v-bind="$attrs">
    <slot></slot>
  </q-footer>
</template>
